/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BannerCreateDto } from '../../models/banner-create-dto';
import { BannerDto } from '../../models/banner-dto';

export interface BannerAdminControllerCreateV1$Params {
      body: BannerCreateDto
}

export function bannerAdminControllerCreateV1(http: HttpClient, rootUrl: string, params: BannerAdminControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BannerDto>> {
  const rb = new RequestBuilder(rootUrl, bannerAdminControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BannerDto>;
    })
  );
}

bannerAdminControllerCreateV1.PATH = '/api/v1/banners/admin';
